import SlimLogosComponent from "./slim-logos-component";
import SlimLogosConfig from "./slim-logos-config";
import SlimLogosAdvancedConfig from "./slim-logos-advanced-config";

export default {
  SlimLogosComponent,
  SlimLogosConfig,
  SlimLogosAdvancedConfig
};
